// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011604/js/" + chunkId + "." + {"44":"a725154a","225":"51cccc1d","481":"e21362ac","486":"4ea15d00","770":"31989423"}[chunkId] + ".0.5126673913521905.chunk.js";
};